/* Judah Lamb — Landing Page behaviours: modals, ad parameters, sticky CTA */
(function () {
  'use strict';

  /* ---------- Modals (order bump, cover blurbs) ---------- */
  function closeModal(modal) {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    var opener = modal.__opener;
    if (opener) { opener.focus(); }
  }

  function openModal(modal, opener) {
    modal.__opener = opener || null;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var first = modal.querySelector('a, button');
    if (first) { first.focus(); }
  }

  document.addEventListener('click', function (e) {
    // Two attributes for the same behaviour: the bump modal predates the
    // generic one, and existing sections still use it.
    var trigger = e.target.closest('[data-lp-modal-open], [data-lp-bump-open]');
    if (trigger) {
      var target = trigger.getAttribute('data-lp-modal-open')
                || trigger.getAttribute('data-lp-bump-open');
      var modal = document.getElementById(target);
      if (modal) {
        e.preventDefault();
        openModal(modal, trigger);
      }
      return;
    }

    var closer = e.target.closest('[data-lp-bump-close]');
    if (closer) {
      e.preventDefault();
      closeModal(closer.closest('.lp-modal'));
      return;
    }

    // Clicking the dark backdrop closes the modal.
    if (e.target.classList && e.target.classList.contains('lp-modal')) {
      closeModal(e.target);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') { return; }
    var open = document.querySelector('.lp-modal.is-open');
    if (open) { closeModal(open); }
  });

  /* ---------- Carry ad parameters and the page variant to checkout ----------
     Two jobs on the same links.

     1. Meta appends fbclid and UTM tags to the landing URL. Navigating to a
        /cart/ permalink drops them, which costs attribution on the order.

     2. Split testing needs the *page* recorded on the order. Cart permalinks
        accept `attributes[key]=value`, and Shopify shows those on the order
        detail page and in the order CSV export. So every cart link carries
        which page produced it.

     The variant name is the page handle unless something overrides it, so a
     duplicated page is tagged correctly with no configuration at all. */
  (function () {
    var incoming = new URLSearchParams(window.location.search);

    // Precedence: explicit markup, then a URL override, then the page handle.
    var tagged = document.querySelector('[data-lp-variant]');
    var variant = (tagged && tagged.getAttribute('data-lp-variant'))
               || incoming.get('lp_variant')
               || window.location.pathname.split('/').filter(Boolean).pop()
                    .replace(/\.[a-z]+$/i, '')      // defensive: strip any extension
               || '';

    if (!Array.from(incoming.keys()).length && !variant) { return; }

    var links = document.querySelectorAll('a[href*="/cart/"]');
    Array.prototype.forEach.call(links, function (a) {
      var href = a.getAttribute('href');
      if (!href) { return; }

      var hashIndex = href.indexOf('#');
      var hash = hashIndex > -1 ? href.slice(hashIndex) : '';
      if (hash) { href = href.slice(0, hashIndex); }

      var parts = href.split('?');
      var params = new URLSearchParams(parts[1] || '');

      incoming.forEach(function (value, key) {
        if (key === 'lp_variant') { return; }   // recorded as an attribute below
        if (!params.has(key)) { params.set(key, value); }
      });

      if (variant && !params.has('attributes[lp_variant]')) {
        params.set('attributes[lp_variant]', variant);
      }

      // URLSearchParams encodes spaces as '+', which is only strictly valid in
      // form-encoded bodies. Discount codes contain spaces, so normalise back
      // to %20 rather than betting a code on the server's leniency.
      // URLSearchParams encodes spaces as '+', which is only strictly valid in
      // form-encoded bodies — discount codes contain spaces. It also encodes
      // the brackets in attributes[...]; Shopify's documented format uses them
      // literally, so put both back.
      var query = params.toString()
        .replace(/\+/g, '%20')
        .replace(/%5B/gi, '[')
        .replace(/%5D/gi, ']');
      a.setAttribute('href', parts[0] + (query ? '?' + query : '') + hash);
    });
  })();

  /* ---------- Mirror the offer button ----------
     A closing CTA should do exactly what the main buy button does, including
     opening the order bump. Configuring both by hand guarantees they diverge
     eventually, so copy the destination and the bump trigger at load instead. */
  (function () {
    var mirrors = document.querySelectorAll('[data-lp-mirror-offer]');
    if (!mirrors.length) { return; }

    var offerBtn = document.querySelector('[data-lp-offer] .lp-offer__cta');
    if (!offerBtn) { return; }   // no offer on this page; keep the fallback link

    var href = offerBtn.getAttribute('href');
    var bump = offerBtn.getAttribute('data-lp-bump-open');

    Array.prototype.forEach.call(mirrors, function (el) {
      if (href) { el.setAttribute('href', href); }
      if (bump) {
        el.setAttribute('data-lp-bump-open', bump);
      } else {
        el.removeAttribute('data-lp-bump-open');
      }
    });
  })();

  /* ---------- Sticky CTA ---------- */
  var sticky = document.querySelector('[data-lp-sticky]');
  if (sticky) {
    var mode = sticky.getAttribute('data-lp-sticky-mode') || 'percent';
    var selector = sticky.getAttribute('data-lp-sticky-after') || '.lp-hook';
    var px = parseInt(sticky.getAttribute('data-lp-sticky-px'), 10);
    var pct = parseInt(sticky.getAttribute('data-lp-sticky-percent'), 10);
    var hideAtOffer = sticky.getAttribute('data-lp-sticky-hide-at-offer') !== 'false';

    if (isNaN(px)) { px = 600; }
    if (isNaN(pct)) { pct = 20; }

    var passedTrigger = function () {
      if (mode === 'section') {
        var anchor = document.querySelector(selector);
        // A selector matching nothing would hide the bar forever, so fall back
        // to the distance rule rather than failing silently.
        if (!anchor) { return window.scrollY > px; }
        return anchor.getBoundingClientRect().bottom < 0;
      }
      if (mode === 'pixels') { return window.scrollY > px; }

      var scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable <= 0) { return false; }
      return (window.scrollY / scrollable) * 100 >= pct;
    };

    var evaluate = function () {
      var trip = passedTrigger();

      // Two buy buttons in one viewport reads as clutter.
      if (trip && hideAtOffer) {
        var offer = document.querySelector('[data-lp-offer]');
        if (offer) {
          var box = offer.getBoundingClientRect();
          if (box.top < window.innerHeight && box.bottom > 0) { trip = false; }
        }
      }

      sticky.classList.toggle('is-visible', trip);
    };

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) { return; }
      ticking = true;
      window.requestAnimationFrame(function () {
        evaluate();
        ticking = false;
      });
    }, { passive: true });
    window.addEventListener('resize', evaluate, { passive: true });

    evaluate();
  }
})();
